__turbopack_context__.v({
  "root": "_5Mq2cG_root",
  "skeleton-shimmer": "_5Mq2cG_skeleton-shimmer",
});
